module.exports = __webpack_public_path__ + "img/capability-slider-img-5.b3c92e6b.png";